import { addDays, startOfDay } from "../../../../../../../../../_shared/_logic/date-math"
import { parseDateLike, toInputDate } from "../../../../../../../_shared/_logic/date-bounds"

const columnIdFor = (employeeId: string | null | undefined, day: Date) => {
  const employeeKey = employeeId || "__unassigned__"
  const dayKey = toInputDate(startOfDay(day))

  return `${employeeKey}-${dayKey}`
}

export const buildBulkCancelableColumnIds = (events: ScheduleEvent[]) => {
  const set = new Set<string>()
  for (const event of events) {
    const start = parseDateLike(event.start_at)
    const end = parseDateLike(event.end_at)

    if (!start || !end || end <= start) continue

    const employeeKey = event.employee_id || "__unassigned__"
    let cursor = startOfDay(start)
    const endDay = startOfDay(new Date(end.getTime() - 1))
    while (cursor.getTime() <= endDay.getTime()) {
      set.add(columnIdFor(employeeKey, cursor))
      cursor = addDays(cursor, 1)
    }
  }

  return Array.from(set)
}
